import React from 'react'
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import { curSym } from '../../../utils/pip';


const Wallet = () => {
    return (
        <div>
            <CoachMenuLayout>
                <div className="ct_px_40 mt-4">
                    <div className="row ">
                        <div className="col-lg-12 mb-0">
                            <div className='d-flex align-items-center gap-3 justify-content-between ct_flex_col_575 ct_w_100_575'>
                                <div>
                                    <h4 className="mb-0 ct_fs_20  mb-1">Your Earnings, Your Growth</h4>
                                    <p className='ct_grey_text mb-0'>Track your earnings, manage withdrawals, and grow your impact — all in one secure place.</p>
                                </div>
                                <div class="position-relative ct_w_100_575">
                                    <input class="form-control ct_input ct_h_40 ps-5 ct_border_radius_10 border-0" style={{ backgroundColor: "hsl(0deg 0% 85% / 30%)" }} placeholder="Search by Title" type="text" />
                                    <i class="fa-solid fa-search ct_input_icon_left"></i>
                                </div>
                            </div>
                            <ul class="ct_table_filter ct_mt_40 border-0">
                                <li class="active active_orange_text">All (8) </li>
                                <li>Workshop (5)</li>
                                <li>Bootcamp (2)</li>
                                <li>Ebooks (1)</li>
                                <li>Ebooks (1)</li>
                                <li>Payouts (2)</li>
                            </ul>

                            {/* All Content Start */}
                            <div className='row gx-5 d-none'>
                                <div className='col-xl-9 mb-4'>
                                    <div className='table-responsive ct_wallet_table ct_custom_table'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Source</th>
                                                    <th>Status</th>
                                                    <th>Date</th>
                                                    <th>Amount</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>PO-00125</td>
                                                    <td>Workshop</td>
                                                    <td>
                                                        <span class="ct_draft_badge">Upcoming</span>
                                                    </td>
                                                    <td>Jan 20, 2026</td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-2 position-relative">
                                                            <select className='form-control ct_input  border-0  ct_h_35 ct_border_radius_10'>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                            </select>
                                                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="ct_right_dropdown dropdown">
                                                            <button id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" class="">
                                                                <i class="fa-solid fa-ellipsis"></i>
                                                            </button>
                                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                <li><a class="dropdown-item" href="#">View Details</a></li>
                                                                <li><a class="dropdown-item ct_darksky_blue_text" href="#">Reschedule</a></li>
                                                                <li><a class="dropdown-item ct_yellow_text" href="#">Send Message </a></li>
                                                                <li><a class="dropdown-item ct_orange_text" href="#">Cancelled </a></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PO-00125</td>
                                                    <td>Workshop</td>
                                                    <td>
                                                        <span class="ct_draft_badge">Upcoming</span>
                                                    </td>
                                                    <td>Jan 20, 2026</td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-2 position-relative">
                                                            <select className='form-control ct_input  border-0  ct_h_35 ct_border_radius_10'>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                            </select>
                                                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="ct_right_dropdown dropdown">
                                                            <button id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" class="">
                                                                <i class="fa-solid fa-ellipsis"></i>
                                                            </button>
                                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                <li><a class="dropdown-item" href="#">View Details</a></li>
                                                                <li><a class="dropdown-item ct_darksky_blue_text" href="#">Reschedule</a></li>
                                                                <li><a class="dropdown-item ct_yellow_text" href="#">Send Message </a></li>
                                                                <li><a class="dropdown-item ct_orange_text" href="#">Cancelled </a></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PO-00125</td>
                                                    <td>Workshop</td>
                                                    <td>
                                                        <span class="ct_draft_badge">Upcoming</span>
                                                    </td>
                                                    <td>Jan 20, 2026</td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-2 position-relative">
                                                            <select className='form-control  ct_input  border-0  ct_h_35 ct_border_radius_10'>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                            </select>
                                                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="ct_right_dropdown dropdown">
                                                            <button id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" class="">
                                                                <i class="fa-solid fa-ellipsis"></i>
                                                            </button>
                                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                <li><a class="dropdown-item" href="#">View Details</a></li>
                                                                <li><a class="dropdown-item ct_darksky_blue_text" href="#">Reschedule</a></li>
                                                                <li><a class="dropdown-item ct_yellow_text" href="#">Send Message </a></li>
                                                                <li><a class="dropdown-item ct_orange_text" href="#">Cancelled </a></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PO-00125</td>
                                                    <td>Workshop</td>
                                                    <td>
                                                        <span class="ct_draft_badge">Upcoming</span>
                                                    </td>
                                                    <td>Jan 20, 2026</td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-2 position-relative">
                                                            <select className='form-control ct_input border-0 ct_h_35 ct_border_radius_10'>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                                <option>{curSym}  2 000</option>
                                                            </select>
                                                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="ct_right_dropdown dropdown">
                                                            <button id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" class="">
                                                                <i class="fa-solid fa-ellipsis"></i>
                                                            </button>
                                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                <li><a class="dropdown-item" href="#">View Details</a></li>
                                                                <li><a class="dropdown-item ct_darksky_blue_text" href="#">Reschedule</a></li>
                                                                <li><a class="dropdown-item ct_yellow_text" href="#">Send Message </a></li>
                                                                <li><a class="dropdown-item ct_orange_text" href="#">Cancelled </a></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>

                                    </div>

                                </div>
                                <div className='col-xl-3 mb-4'>
                                    <div className='ct_mt_10'>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_py_10_px_30'>
                                            <div id="ct_coaching_chart"></div>


                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Available Balance </h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 2 560</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Funds that are ready for withdrawal or use</li></ul>

                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Pending Balance  </h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 960</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Payments from upcoming or recently completed sessions</li></ul>

                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Withdrawal Amount</h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 960</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Payments from upcoming or recently completed sessions</li></ul>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* All Content End */}

                            {/* payouts Content S */}
                            <div className='row gx-5 '>
                                <div className='col-xl-9 mb-4'>
                                    <div>
                                        <div className='ct_payouts_light_blue_bg_12'>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_flex_col_575'>
                                                <div>
                                                    <p className='ct_fs_18 ct_darksky_blue_text ct_mb_50'>Request your collected rewards and request a payout </p>
                                                    <h2 className='mb-0 ct_fs_32 ct_darksky_blue_text'>Balance </h2>
                                                </div>
                                                <button className='ct_yellow_btn ct_yellow_btn_text_blue ct_h_35 ct_border_radius_10 ct_white_nowrap' data-bs-target="#ct_request_payout" data-bs-toggle="modal">Request a payout</button>

                                            </div>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_mt_50 pt-2 flex-wrap'>
                                                <div>
                                                    <p className='ct_fs_18 ct_darksky_blue_text ct_text_op_6 ct_mb_26'>Current balance  </p>
                                                    <h3 className='mb-0 ct_fs_32 ct_darkblue_text'>{curSym}  24 050.00</h3>
                                                </div>
                                                <div>
                                                    <p className='ct_fs_18 ct_darksky_blue_text ct_text_op_6 ct_mb_26'>Paid</p>
                                                    <h3 className='mb-0 ct_fs_32 ct_darkblue_text'>0.00 </h3>
                                                </div>
                                                <div>
                                                    <p className='ct_fs_18 ct_darksky_blue_text ct_text_op_6 ct_mb_26'>Total </p>
                                                    <h3 className='mb-0 ct_fs_32 ct_darkblue_text'>{curSym}  24 050.00</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='ct_outline_bg ct_mt_16 h-100'>
                                            <p className='ct_fs_18 ct_darksky_blue_text'>Payment History </p>
                                            <div className='ct_payment_empty_payout_cnt'>
                                                <img src='../../assets/img/pay_request_empty_icon.png' />
                                                <p className=' ct_fs_18 ct_text_clr_7D818D mb-0 text-center'>
                                                    Payout requests live here <br />
                                                    When you start requesting for payouts, you will see them listed here
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className='col-xl-3 mb-4'>
                                    <div className='ct_mt_10'>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_py_10_px_30'>
                                            <div id="ct_coaching_chart"></div>


                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Available Balance </h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 2 560</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Funds that are ready for withdrawal or use</li></ul>

                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Pending Balance  </h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 960</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Payments from upcoming or recently completed sessions</li></ul>

                                        </div>
                                        <div className='ct_outline_bg ct_border_radius_10 ct_mt_18 '>
                                            <div className='d-flex align-items-center justify-content-between gap-3 ct_py_10_px_30'>
                                                <div>
                                                    <h6 className='ct_fs_16 ct_orange_text ct_mb_16'>Withdrawal Amount</h6>
                                                    <h4 className='ct_fs_24 ct_darkblue_text'>{curSym} 960</h4>
                                                </div>
                                                <div className='ct_price_money_icon_30 ct_flex_shrink_0'>
                                                    <img src='../../assets/img/price_money_icon.svg' />
                                                </div>

                                            </div>

                                            <ul class="d-flex align-items-center gap-2 ct_mt_16">
                                                <li class="ct_fs_12 ct_text_clr_8ECAE6">
                                                    38%
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_6182_32362)">
                                                            <path d="M5.88168 14.0677L15.9853 8.23438" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.89829 6.3598L16.2731 8.06792L14.565 14.4427" stroke="#8ECAE6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6182_32362">
                                                                <rect width="16" height="16" fill="white" transform="translate(21.8564 8) rotate(120)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                </li>
                                                <li class="ct_text_op_2">|</li><li class="ct_grey_text ct_fs_12">Payments from upcoming or recently completed sessions</li></ul>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            {/* payouts Content E */}





                        </div>
                    </div>
                </div>
            </CoachMenuLayout>

            {/* Payout request modal S */}
            <div
                class="modal fade modal-lg"
                id="ct_request_payout"
                tabindex="-1"
                aria-labelledby="ct_request_payouttLabel"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-centered " style={{ maxWidth: "617px" }}>
                    <div class="modal-content ct_border_radius_20 border-0 ">
                        <div class="modal-header border-0">
                            <button
                                type="button"
                                class="btn-close ct_circle_close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body py-0 ct_px_84">
                            <div className='text-center'>
                                <h4 class="mb-1 ct_fs_24_new ct_darksky_blue_text px-4 mb-2">Request a payout</h4>
                                <p class="mb-0 ct_grey_text px-4 mx-auto" style={{ maxWidth: "506px" }}>
                                    Please complete all fields correctly, or we will be unable to process your payout request.
                                </p>
                            </div>

                            <div className='px-4 ct_mt_20'>
                                <label for="" class="d-block mb-2">Payout </label>
                                <div className='form-control ct_input h-auto ct_py_12'>

                                    <p className='ct_fs_14 ct_darkblue_text ct_text_op_6 mb-2'>Amount </p>
                                    <h5 className='mb-0 ct_fs_20_new ct_darkblue_text'>5,200.00 USD</h5>

                                </div>

                                <div
                                    class="d-flex align-items-center gap-3 justify-content-center pt-4"
                                >
                                    <button class="ct_yellow_btn ct_outline_grey ct_px_60 ct_h_44 ct_white_nowrap w-100">
                                        Bank
                                    </button>
                                    <button
                                        class="ct_yellow_btn ct_sky_blue_btn ct_px_60 ct_h_44 ct_white_nowrap w-100"

                                    >
                                        PayPal
                                    </button>
                                </div>

                            </div>
                            <form
                                action="javascript:void(0)"
                                class="ct_mt_50 ct_modal_scroll ct_custom_scroll"
                            >
                                <div class="row px-4">
                                    <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="" class="d-block mb-2">Full Name</label>
                                            <input
                                                type="text"
                                                class="form-control ct_input"
                                                placeholder="My name "
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="" class="d-block mb-2">PayPal email</label>
                                            <input
                                                type="email"
                                                class="form-control ct_input"
                                                placeholder="e.g. alexbrown@gmail.com"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="" class="d-block mb-2">Tax ID ( If available ) </label>
                                            <input
                                                type="text"
                                                class="form-control ct_input"
                                                placeholder="Tax ID"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="d-flex align-items-center gap-3 justify-content-center pt-4 ct_flex_col_575 px-4"
                                >
                                    <button class="ct_yellow_btn ct_outline_grey ct_px_60 ct_h_44 ct_w_100_575">
                                        Cancel
                                    </button>
                                    <button
                                        class="ct_yellow_btn ct_sky_blue_btn ct_px_60 ct_h_44 ct_w_100_575"
                                        data-bs-toggle="modal"
                                        data-bs-target="#ct_submit_modal"
                                    >
                                        Request
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Payout request modal S */}


            {/* Payout Success Modal S */}
            <div
                class="modal fade ct_submit_modal"
                id="ct_submit_modal"
                tabindex="-1"
                aria-labelledby="ct_submit_modalLabel"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header border-0">
                            <button
                                type="button"
                                class="btn-close ct_circle_close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body pb-5">
                            <div class="mx-auto d-block text-center mb-4">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z" fill="#219EBC" />
                                </svg>

                            </div>
                            <div class="text-center">
                                <h4 class="ct_fs_20">Payout Request Submitted</h4>
                                <p className='mx-auto' style={{ maxWidth: "400px" }}>
                                    Payout request processed. Funds will appear in your account soon.
                                </p>
                            </div>
                            <div
                                class="text-center ct_mt_30 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575"
                            >
                                <button
                                    class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575"
                                >
                                    Request a payout
                                </button>
                                <button
                                    class="ct_yellow_btn ct_sky_blue_btn ct_h_48 px-5 ct_w_100_575"
                                    data-bs-dismiss="modal"
                                >
                                    View payouts
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Payout Success Modal E */}
        </div>
    )
}

export default Wallet